package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RequestOtpResponse(
    val message: String = "",
    @SerialName("resend_available_in_seconds")
    val resendAvailableInSeconds: Int = 60
)

@Serializable
data class VerifyOtpResponse(
    @SerialName("access_token")
    val accessToken: String = "",
    @SerialName("token_type")
    val tokenType: String = "bearer",
    @SerialName("user_id")
    val userId: String = "",
    @SerialName("identity_context_profiles")
    val identityContextProfiles: List<IdentityContextProfile> = emptyList(),
    @SerialName("app_staff_id")
    val appStaffId: String? = null,
    @SerialName("school_staff_id")
    val schoolStaffId: String? = null,
    @SerialName("parent_id")
    val parentId: String? = null
)

@Serializable
data class IdentityContextProfile(
    @SerialName("role_assignment_id")
    val roleAssignmentId: String = "",
    @SerialName("staff_id")
    val staffId: String? = null,
    @SerialName("app_staff_id")
    val appStaffId: String? = null,
    @SerialName("school_staff_id")
    val schoolStaffId: String? = null,
    @SerialName("parent_id")
    val parentId: String? = null,
    @SerialName("role_id")
    val roleId: Int? = null,
    @SerialName("school_id")
    val schoolId: String? = null,
    @SerialName("school_name")
    val schoolName: String? = null
)

internal fun IdentityContextProfile.resolveRoleCode(): String = when (roleId) {
    1 -> com.schoolconnect.app.domain.SchoolKeys.V_ROLE_APP_SUPER_ADMIN
    2 -> com.schoolconnect.app.domain.SchoolKeys.V_ROLE_APP_ADMIN
    3 -> com.schoolconnect.app.domain.SchoolKeys.V_ROLE_APP_BACKEND
    4 -> com.schoolconnect.app.domain.SchoolKeys.V_ROLE_SCHOOL_ADMIN
    // Database role ids: 5=SCHOOL_MGMT, 6=SCHOOL_TEACHER,
    // 7=PARENT, 8=SCHOOL_SUPPORT_STAFF.
    5 -> com.schoolconnect.app.domain.SchoolKeys.V_ROLE_SCHOOL_ADMIN
    6 -> com.schoolconnect.app.domain.SchoolKeys.V_ROLE_TEACHER
    7 -> com.schoolconnect.app.domain.SchoolKeys.V_ROLE_PARENT
    8 -> com.schoolconnect.app.domain.SchoolKeys.V_ROLE_SUPPORT_STAFF
    else -> if (schoolId.isNullOrBlank()) {
        com.schoolconnect.app.domain.SchoolKeys.V_ROLE_APP_ADMIN
    } else {
        com.schoolconnect.app.domain.SchoolKeys.V_ROLE_SCHOOL_ADMIN
    }
}
